import {Routes} from '@angular/router';
import {LoginComponent} from './components/pages/guest/login/login.component';
import {RegisterComponent} from './components/pages/guest/register/register.component';
import {HomeComponent} from './components/pages/home/home.component';
import {AuthGuardService} from './services/auth-guard/auth-guard.service';
import {OfferListComponent} from './components/pages/offers/offer-list/offer-list.component';
import {ReportTabComponent} from './components/pages/reports/report-tab/report-tab.component';
import {PaymentListComponent} from './components/pages/payments/payment-list/payment-list.component';
import {PostbackListComponent} from './components/pages/tools/postbacks/postback-list/postback-list.component';
import {NotificationsComponent} from './components/pages/misc/notifications/notifications.component';
import {MyAccountComponent} from './components/pages/my-account/my-account.component';
import {ApiComponent} from './components/pages/misc/api/api.component';
import {AccountComponent} from './components/pages/misc/account/account.component';
import {ClickReportComponent} from './components/pages/reports/click-report/click-report.component';
import {ConversionReportComponent} from './components/pages/reports/conversion-report/conversion-report.component';
import {PasswordLostComponent} from './components/pages/guest/password-lost/password-lost.component';
import {RegisterSuccessComponent} from './components/pages/guest/register-success/register-success.component';
import {PasswordResetComponent} from './components/pages/guest/password-reset/password-reset.component';
import {OfferViewComponent} from './components/pages/offers/offer-view/offer-view.component';
import {BasicReportComponent} from './components/pages/reports/basic-report/basic-report.component';
import {OfferReportComponent} from './components/pages/reports/offer-report/offer-report.component';
import {
  UnsubscribeFormComponent
} from './components/pages/tools/unsubscribe/unsubscribe-form/unsubscribe-form.component';

export const routes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'register', component: RegisterComponent},
  {path: 'register/success', component: RegisterSuccessComponent},
  {path: 'password-lost', component: PasswordLostComponent},
  {path: 'password-reset', component: PasswordResetComponent},

  {path: '', component: HomeComponent, canActivate: [AuthGuardService]},

  {path: 'offer/:id', component: OfferViewComponent, canActivate: [AuthGuardService]},
  {path: 'offers', component: OfferListComponent, canActivate: [AuthGuardService]},

  {
    path: 'reports', component: ReportTabComponent, canActivate: [AuthGuardService], children: [
      {path: 'offer', component: OfferReportComponent, canActivate: [AuthGuardService]},
      {path: 'conversion', component: ConversionReportComponent, canActivate: [AuthGuardService]},
      {path: 'click', component: ClickReportComponent, canActivate: [AuthGuardService]},
      {path: ':report', component: BasicReportComponent, canActivate: [AuthGuardService]},
      {path: '', pathMatch: 'prefix', redirectTo: '/reports/daily'},
    ]
  },

  {path: 'payments', component: PaymentListComponent, canActivate: [AuthGuardService]},

  {path: 'tools/postbacks', component: PostbackListComponent, canActivate: [AuthGuardService]},
  {path: 'tools/optout', component: UnsubscribeFormComponent, canActivate: [AuthGuardService]},

  {path: 'my-account', component: MyAccountComponent, canActivate: [AuthGuardService]},

  // Top navbar
  {path: 'api', component: ApiComponent, canActivate: [AuthGuardService]},
  {path: 'account', component: AccountComponent, canActivate: [AuthGuardService]},
  {path: 'notifications', component: NotificationsComponent, canActivate: [AuthGuardService]},

  {path: '**', redirectTo: ''}
];
